import { render, staticRenderFns } from "./AssetsAndProductsStarter.vue?vue&type=template&id=9fceabfc&"
import script from "./AssetsAndProductsStarter.vue?vue&type=script&lang=js&"
export * from "./AssetsAndProductsStarter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports